import { Box } from "@mui/material";
import { Button, Modal } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";
const ActionButtons = ({ handleSave, title, content, navigatePath = "/stocks" }) => {
  const navigate = useNavigate();
  return (
    <div style={{ display: "flex", justifyContent: 'end', gap: 5, marginTop: 20}}>
      
        <Button
          onClick={() => {
            navigate(navigatePath);
          }}
        >
          Cancel
        </Button>
        <Button
          type="primary"
          // onClick={handleSave}
          onClick={() => {
            Modal.confirm({
              title: title,
              centered: true,
              content: content,
              onOk: () => handleSave(),
              okText: 'Save',
              width: 600,
              okButtonProps: { size: "large" },
              cancelButtonProps: { size: "large" },
            });
          }}
        >
          Save
        </Button>

      
    </div>
  );
};

export default ActionButtons;
